import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useMe } from '../lib/me';
import './NotFound.css';

/**
 * There is nothing at this address.
 *
 * Every unknown URL used to be redirected to the ticket list without a word,
 * so a mistyped or stale deep link - /ticket/123, an old /dashboard - gave
 * somebody their tickets and no idea why. In the style of FeatureRoute's
 * "switched off" page: calm, says which address, and one way out. `home` is
 * where the bar's logo goes: the hub for an administrator, My tickets for
 * everybody else, the portal for a contractor.
 */
export default function NotFound({ home = '/my-tickets', homeLabel = 'Go to my tickets' }) {
  const { pathname } = useLocation();
  const me = useMe();
  return (
    <div className="container">
      <section className="nf" role="status" aria-live="polite">
        <span className="nf-ico" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="7" />
            <path d="m20 20-3.5-3.5" />
            <path d="M8.5 8.5l5 5M13.5 8.5l-5 5" />
          </svg>
        </span>
        <h1 className="nf-title">There is nothing at this address</h1>
        <p className="nf-text">
          <code className="nf-path">{pathname}</code> is not a page in Jarvis. The link may be
          out of date, or the address mistyped.
        </p>
        <div className="nf-actions">
          <Link className="btn btn-primary" to={home}>{homeLabel}</Link>
          {me?.signedIn && !me?.isAdmin && (
            <Link className="btn btn-secondary" to="/create">Raise a ticket</Link>
          )}
        </div>
      </section>
    </div>
  );
}
